import React, { createContext, useState, useContext } from "react";

// Create context
const SearchContext = createContext();

// Provider
export const SearchProvider = ({ children }) => {
  const [selectedEvent, setSelectedEvent] = useState(null);

  return (
    <SearchContext.Provider value={{ selectedEvent, setSelectedEvent }}>
      {children}
    </SearchContext.Provider>
  );
};

// Custom hook (for easier usage)
export const useSearch = () => useContext(SearchContext);
